const commonModule = {
  state: {
    // 當前社區Id
    // currentCommunityId: '8d048b06-88c5-4028-98a7-bc4e66714d90',
    currentCommunityId: localStorage.getItem('COMMUNITY_ID'),
    // 當前社區的名稱
    currentCommunityName: ''
  },
  actions: {},
  mutations: {
    SET_CURRENT_COMMUNITY_ID(state, payload) {
      state.currentCommunityId = payload
    },
    SET_CURRENT_COMMUNITY_NAME(state, payload) {
      state.currentCommunityName = payload
    }
  },
  getters: {
    currentCommunityId: (state) => state.currentCommunityId,
    currentCommunityName: (state) => state.currentCommunityName
  },
  namespaced: true
}

export default commonModule
